export function Header(): JSX.Element {
  return (
    <div className="header" id="app-title">
      👶 Baby Names 👶
    </div>
  );
}
